import React from 'react';
import FullLogo from '../Photos/Fulllogo.png';
import Panels1 from '../Photos/Panels1.jpg';
import Panels2 from '../Photos/Panels2.jpg';
import Panels3 from '../Photos/Panels3.jpg';
import Panels4 from '../Photos/Panels4.jpg';
import PanelCAD from '../Photos/PanelCAD.png';
import Freestanding from '../Photos/Freestanding.jpg';
import Freestanding2 from '../Photos/Freestanding2.jpg';

function FreestandingPannels() {
  return (
    <div className="container mt-5">

 {/* Additional Images */}
      <div className="row g-4 mb-5">
        <div className="col-md-4">
          <img src={Panels1} alt="Image 1" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Panels2} alt="Image 2" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
        <div className="col-md-4">
          <img src={Freestanding2} alt="Image 3" className="img-fluid rounded shadow" />
          <p className="text-center mt-2"></p>
        </div>
      </div>

      {/* Full-Width Image Section with Two Images Side by Side */}
      <div className="row g-0 mb-5">
        <div className="col-md-6">
          <img src={Freestanding} alt="Full Width Image 1" className="img-fluid w-100" />
        </div>
        <div className="col-md-6">
          <img src={PanelCAD} alt="Full Width Image 2" className="img-fluid w-100" />
        </div>
      </div>

      {/* Full-Width Text Box */}
      <div className="get-in-touch-card mb-5 p-4">
        <div className="card-body">
          <h2 style={{ color: '#c92424' }}>Freestanding Panels</h2>
          <p className="card-text">
            Our standard freestanding panels are full fame 5 rod panels 24 feet long. The full frame panels ensures good rejidity and 
            5 rods keep animals from getting their heads between the bars. These panels are perfect for a variety of applications, and can be 
            tailored to application. Contact us if you would like to order standard panels or if you have an application for purpose built freestanding panels with your specifications! 
          </p>
        </div>
      </div>
    

      

          {/* Google Maps and Address Section */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-info mb-3">Find Us on the Map</h3>
          <iframe
            title="Google Map Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d137778.5034484805!2d-96.8170804273567!3d40.26456281736707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x879642a907fb410b%3A0x92e39ab059d18d3d!2sBeatrice%2C%20NE%2068310!5e0!3m2!1sen!2sus!4v1756762112857!5m2!1sen!2sus" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <div className="col-md-6 d-flex flex-column">
          <h3 className="text-info mb-3">Contact Us</h3>
          <div className="card p-3 enlarged-address-card flex-grow-1">
            <p className="card-text">
              Address:<br />
              2670 W Linden Rd<br />
              Beatrice, NE 68310<br />
              <br />
              <br />
              Email: eoltmans3@gmail.com<br />
              <br />
              Phone: (402) 239-4323
            </p>
          </div>
          <div className="flex-grow-1 mt-3">
            <img src={FullLogo} alt="Company Logo" className="img-fluid w-100" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FreestandingPannels;